const API_URL = '/b2b/api';

export const getTextsUrl = `${API_URL}/contents/texts`;
export const verifyDataUrl = `${API_URL}/verify`;
export const personalInfoUrl = `${API_URL}/personalinfo`;
export const getCodeParamsUrl = `${API_URL}/code`;
export const pollingUrl = `${API_URL}/polling`;
